import { useQueryFetch } from './useQueryFetch';
import { apiExpress } from 'lib/config';

interface PresignedUrl {
  url: string;
  id?: number;
}

interface PresignedUrlParams {
  fileName: string;
  type: string;
  id?: number;
}
export const usePresignedUrl = () => {
  const { data, error, loading, fetchData } = useQueryFetch({});

  // const presignedUrlArr = [];
  const fetch = (data: PresignedUrlParams) => {
    fetchData(
      {
        method: 'get',
        url: `aws/signedurl?filename=${data.fileName}&filetype=${data.type}`,
        baseURL: apiExpress,
      },
      data.hasOwnProperty('id') ? data.id : undefined
    );
  };

  const presignedUrl: PresignedUrl = data;
  // presignedUrlArr.push(presignedUrl);
  return { presignedUrl, loading, error, fetch };
  // return { presignedUrlArr, loading, error, fetch };
};
